import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAtom } from "jotai";
import type { JSX } from "react";

import { FormTextAreaQuestion } from "@/components/onboarding/form-text-area-question";
import { consultingAtom } from "@/lib/atoms/consulting-atom";

const ConsultingExpectativaPage = (): JSX.Element => {
  const navigate = useNavigate();
  const [form, setForm] = useAtom(consultingAtom);

  const handleChange = (value: string): void => {
    setForm((prev) => ({ ...prev, expectativa: value }));
  };

  const handleContinue = (): void => {
    void navigate({
      to: "/onboarding/welcome-meeting/schedule",
      search: { consulting: true },
    });
  };

  return (
    <FormTextAreaQuestion
      title="Imagine que estamos daqui a 90 dias"
      subtitle="O que precisaria ter acontecido para você sentir que teve um começo de muito sucesso na Livance?"
      progress={0.82}
      value={form.expectativa}
      onChange={handleChange}
      onContinue={handleContinue}
      metadataTranscriptionTracking={{ feature: "consultoria" }}
    />
  );
};

export const Route = createFileRoute("/onboarding/consulting/expectation")({
  component: ConsultingExpectativaPage,
});
